/**
 * Chữ của "Gộp hồ sơ trùng" ở hồ sơ khách (STT 2.5, ADR-091, docs/plans/stt-2-5-gop-ho-so.md mục 12).
 * Tiếng Việt có dấu, câu ngắn, không thuật ngữ IT; chỉ nói "hồ sơ / khách / lịch hẹn" — trung tính ngành.
 * Câu LÝ DO không gộp được do MÁY CHỦ trả (messageVi) — không viết lại ở đây.
 */
export const GK = {
  // ---- Nút mở (ở mục "Thêm" của hồ sơ khách)
  nutMo: 'Gộp với hồ sơ khác',

  // ---- Bước 1: chọn hồ sơ còn lại
  tieuDeChon: 'Gộp hồ sơ trùng',
  giaiThichChon: 'Chọn hồ sơ còn lại của cùng một khách. Lịch hẹn và ghi chú sẽ về một hồ sơ.',
  oTim: 'Tìm theo tên hoặc số điện thoại',
  coTheTrung: 'Có thể trùng',
  khongGoiY: 'Không thấy hồ sơ nào giống. Bạn tìm theo tên hoặc số ở ô trên.',
  ketQuaTim: 'Kết quả tìm',
  khongThay: 'Không tìm thấy hồ sơ nào.',
  dangTim: 'Đang tìm…',
  coZalo: 'Có Zalo',
  chuaZalo: 'Chưa có Zalo',
  chuaCoSo: 'Chưa có số',

  // ---- Bước 2: xem trước
  tieuDeXem: 'Xem trước khi gộp',
  theGiu: 'Giữ hồ sơ này',
  theBo: 'Gộp vào rồi ẩn',
  // Nhãn thẻ theo NGUỒN (hồ sơ đang mở / hồ sơ kia) — màn bị chặn cũng đọc đúng, không hứa "giữ / ẩn".
  hoSoDangMo: 'Hồ sơ đang mở',
  hoSoKia: 'Hồ sơ kia',
  vaiGiu: 'Giữ lại',
  vaiBo: 'Gộp vào rồi ẩn',
  doiChieu: (ten: string) => `Đổi: giữ hồ sơ "${ten}" làm hồ sơ chính`,
  tieuCanhBao: 'Cần xem trước khi gộp',
  // Máy tự đảo chiều vì hồ sơ đang mở có tiền / gói nên không ẩn được.
  maDaoChieu: (ten: string) =>
    `Hồ sơ "${ten}" đã có tiền hoặc gói nên không ẩn được. Vì vậy hồ sơ đang mở sẽ được gộp vào "${ten}".`,
  chonSoOTren: 'Chọn số ở trên',
  soLichSau: (n: number) => `${n} lịch hẹn`,
  luuYSau: (s: string) => `Lưu ý: ${s}`,
  soLich: (n: number, m: number) => (m > 0 ? `${n} lịch hẹn (${m} sắp tới)` : `${n} lịch hẹn`),
  khongGopDuoc: 'Chưa gộp được',
  goiYDaORTren: 'Các hồ sơ giống đã hiện ở "Kết quả tìm" phía trên.',
  lanCuoi: (d: string) => `Lần cuối tới ${d}`,
  chuaTungToi: 'Chưa có lần tới nào',
  ngaySinh: (d: string) => `Sinh ${d}`,
  coTien: 'Có tiền hoặc gói',
  chuaTien: 'Chưa có tiền',
  sauGop: 'Sau khi gộp',
  nhanTin: (co: boolean) => `Nhận tin ưu đãi: ${co ? 'Có' : 'Không'}`,
  luuAnh: (co: boolean) => `Cho lưu ảnh: ${co ? 'Có' : 'Không'}`,
  zalo: (co: boolean) => `Zalo: ${co ? 'Có' : 'Không'}`,
  hoiSo: 'Giữ số nào?',
  goiYSo:
    'Số còn lại được chép vào Lưu ý, không còn dùng để tìm khách. Lần đặt sau bằng số đó sẽ tạo hồ sơ mới.',
  // Nhãn nút chọn số: số này thuộc hồ sơ nào, và nếu chọn thì hồ sơ đó giữ lại hay bị gộp.
  soCuaHoSo: (ten: string) => `Số của hồ sơ "${ten}"`,
  hauQuaSo: (so: string) =>
    `Số ${so} sẽ được chép vào Lưu ý, không còn dùng để tìm khách. Lần đặt sau bằng số này sẽ tạo hồ sơ mới.`,
  daChon: 'Đã chọn',
  chonSoNhac: 'Bạn chọn giữ số điện thoại nào nhé.',
  // Zalo của hồ sơ bị gộp ĐI VÀO hồ sơ giữ (N1): nói thẳng hậu quả — người dùng Zalo này sẽ thấy gói, ví, huỷ được lịch.
  canhBaoZalo: (bo: string, giu: string) =>
    `Tài khoản Zalo của hồ sơ "${bo}" sẽ chuyển sang "${giu}". Người dùng Zalo này sẽ thấy gói, ví và huỷ được lịch của hồ sơ này. Chỉ gộp khi khách đang ở tiệm và mở Zalo cho bạn xem.`,
  canhBaoChoXacNhan: (giu: string) =>
    `Sau khi gộp, hồ sơ "${giu}" chờ bạn bấm "Đúng người" ở mục Chờ xác nhận Zalo. Trước đó khách chưa thấy gói và ví trong ứng dụng.`,
  // Hồ sơ giữ ĐÃ có Zalo (N2): khách Zalo ấy sẽ thấy lịch (và số) của hồ sơ bị gộp.
  canhBaoZaloGiu: (giu: string, n: number, soGan: boolean) =>
    `Khách Zalo của hồ sơ "${giu}" sẽ thấy ${n} lịch của hồ sơ bị gộp${soGan ? ', và số điện thoại của hồ sơ đó sẽ gắn vào hồ sơ này' : ''}. Chỉ gộp khi đúng là cùng một người.`,
  // Chỉ báo hậu quả (KHÔNG chặn, không ra lệnh trái với nút "Tiếp tục"): hai lịch trùng giờ vẫn gộp được.
  canhBaoLichTrung: (gio: string, maA: string, maB: string) =>
    `Hai lịch trùng giờ ${gio} (mã ${maA} và ${maB}): sau khi gộp khách có hai lịch cùng lúc.`,
  // Bản NGẮN nhắc lại ở bước xác nhận (đủ mọi cảnh báo nặng + nhẹ, mỗi cái một dòng).
  ngan: {
    zaloChuyen: (bo: string, giu: string) =>
      `Zalo của "${bo}" chuyển sang "${giu}": người dùng Zalo đó thấy gói, ví và huỷ được lịch.`,
    choXacNhan: (giu: string) =>
      `"${giu}" chờ bạn bấm "Đúng người" rồi khách mới thấy gói, ví trong ứng dụng.`,
    zaloGiu: (giu: string, n: number, soGan: boolean) =>
      `Khách Zalo của "${giu}" sẽ thấy ${n} lịch${soGan ? ' và số điện thoại' : ''} của hồ sơ bị gộp.`,
    uuDai: (bo: string) => `Ưu đãi chưa dùng của "${bo}" sẽ mất.`,
    anh: (n: number) => `${n} ảnh sẽ bị xoá (khách tắt lưu ảnh).`,
    lichTrung: (gio: string, a: string, b: string) =>
      `Hai lịch trùng giờ ${gio} (${a}, ${b}): khách có hai lịch cùng lúc.`,
  },
  canhBaoUuDai: (bo: string) => `Ưu đãi chưa dùng của hồ sơ "${bo}" sẽ không dùng được nữa.`,
  canhBaoAnh: (n: number) => `Khách đã tắt cho lưu ảnh: ${n} ảnh sẽ bị xoá.`,
  tiepTuc: 'Tiếp tục',
  dong: 'Đóng',

  // ---- Bước 3: xác nhận
  tieuDeXacNhan: 'Gộp hai hồ sơ?',
  cauXacNhan: (bo: string) =>
    `Hồ sơ "${bo}" sẽ ẩn và không tách lại được. Chỉ gộp khi chắc chắn là cùng một người.`,
  // Có Zalo ở bất kỳ bên nào: một ô tích RIÊNG trước khi gộp (không chỉ bấm nút).
  xacNhanZalo: 'Khách đang ở tiệm và đã mở Zalo cho tôi xem.',
  nhacXacNhanKhach: 'Hãy xác nhận khách đang ở tiệm trước.',
  tieuNhacLai: 'Trước khi gộp, bạn nhớ',
  nutGop: 'Gộp hai hồ sơ',
  dangGop: 'Đang gộp…',
  quayLai: 'Quay lại',

  // ---- Xong / lỗi
  xong: (giu: string) => `Đã gộp. Lịch hẹn và ghi chú đã về hồ sơ "${giu}".`,
  daGopChuyen: 'Hồ sơ này đã được gộp. Đang mở hồ sơ còn lại.',
  mangCham:
    'Mạng chậm, chưa chắc đã gộp. Bấm "Gộp hai hồ sơ" lại — hai hồ sơ không bị gộp hai lần.',
  // Sau gộp mà hồ sơ giữ đang chờ xác nhận Zalo: nhắc việc kế tiếp.
  nhacDungNguoi:
    'Nhớ bấm "Đúng người" ở mục Chờ xác nhận Zalo (Khách → Tìm khách) khi khách đang ở tiệm.',
  moMucCho: 'Xem mục Chờ xác nhận Zalo',
  daGopMoiXem: 'Hồ sơ vừa đổi, bạn xem lại trước khi gộp nhé.',
  lanCuoiGoiY: (d: string) => `lần cuối tới ${d}`,
  loiChung: 'Chưa gộp được. Bạn thử lại nhé.',
  loiXemTruoc: 'Chưa xem trước được. Bạn thử lại nhé.',
} as const
